import React from 'react'
import { history } from './../../helpers/history'
import { isMobile } from './../../helpers/window.helper'
import { StyledContainer } from './styled-components.component'
import { StyledProductItem } from '../../modules/launch/components/product-item.styled'

export class StoreProductOverview extends React.Component {
	render() {
		const {
			name,
			points,
			pointsForSubscribers,
			src,
			id,
			priceNotMember,
			priceForMember,
		} = this.props

		const hasPoints = priceNotMember == null && priceForMember == null

		return (
			<StyledProductItem>
				<StyledContainer
					onClick={() => history.push(`/loja/produto/${id}`)}>
					<div className="image-container">
						<img src={src} alt={name} />
					</div>
					<div className="info-container">
						<div className="name-container">
							<p className={`name ${isMobile() ? 'center' : ''}`}>
								{name}
							</p>
						</div>
						<div className="footer-container">
							<p className={'label-price-container'}>
								<span className={'startingAt'}>A partir de</span>
								{hasPoints ? (
									<span className={'blue points'}>
										{points.toLocaleString('pt-BR')} pontos
									</span>
								) : (
									<span className={'blue points'}>
										{priceNotMember.$toReais()}
									</span>
								)}
							</p>
							<a className="btn-details" href={`/loja/produto/${id}`}>
								QUERO ESTE
							</a>
						</div>
					</div>
				</StyledContainer>
			</StyledProductItem>
		)
	}
}

export default StoreProductOverview
